export const fromLongToShort = {
  ar_AE: 'ar',
  br_BR: 'br',
  de_DE: 'de',
  en_US: 'en',
  es_ES: 'es',
  fr_FR: 'fr',
  hi_IN: 'hi',
  hu_HU: 'hu',
  id_ID: 'id',
  it_IT: 'it',
  ja_JP: 'ja',
  ko_KO: 'ko',
  pl_PL: 'pl',
  pt_PT: 'pt',
  ro_RO: 'ro',
  ru_RU: 'ru',
  tr_TR: 'tr',
  vi_VN: 'vi',
  enpam: 'en',
  zh_ZH: 'zh',
};

export const fromShortToLong = {
  ar: 'ar_AE',
  br: 'br_BR',
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  hi: 'hi_IN',
  hu: 'hu_HU',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KO',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ro: 'ro_RO',
  ru: 'ru_RU',
  tr: 'tr_TR',
  vi: 'vi_VN',
  enpam: 'en_US',
  zh: 'zh_ZH',
};

export const availableInEN = {
  ar: 'ar_AE',
  br: 'br_BR',
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  hi: 'hi_IN',
  hu: 'hu_HU',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KO',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ro: 'ro_RO',
  ru: 'ru_RU',
  tr: 'tr_TR',
  vi: 'vi_VN',
};

export const availableInDE = {
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  hu: 'hu_HU',
  it: 'it_IT',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ru: 'ru_RU',
  tr: 'tr_TR',
};

export const availableInES = {
  en: 'en_US',
  hu: 'hu_HU',
};

export const availableInFR = {
  en: 'en_US',
  hu: 'hu_HU',
};

export const availableInENPAM = {
  hu: 'hu_HU',
};

export const availableInHU = {
  ar: 'ar_AE',
  br: 'br_BR',
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  hi: 'hi_IN',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KO',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ro: 'ro_RO',
  ru: 'ru_RU',
  tr: 'tr_TR',
  vi: 'vi_VN',
  tl: 'tl_TL',
  ky: 'ky_KY',
  uz: 'uz_UZ',
  zh: 'zh_ZH',
};

export const availableInESP = {
  en: 'en_US',
  hu: 'hu_HU',
  de: 'de_DE',
  es: 'es_ES',
  fr: 'fr_FR',
  it: 'it_IT',
  pt: 'pt_PT',
  ru: 'ru_RU',
  zh: 'zh_ZH',
};

const detectSubDomain = () => {
  try {
    const full = window.location.host;
    // window.location.host is subdomain.domain.com
    const parts = full.split('.');
    const sub = parts[0];
    return sub;
  } catch (e) {
    return undefined;
  }
};

// Detect subdomain and after browser language
export const detectBrowserLanguage = () => {
  const subDomain = detectSubDomain();
  if (subDomain && subDomain.length == 2) {
    return fromShortToLong[subDomain];
  }
  return 'en_US';
  /* let locale = navigator.language;
  if (locale) {
    locale = locale.split('-')[0];
    locale = fromShortToLong[locale];
  }
  if (!locale) {
    locale = 'en_US';
  }
  return locale; */
};
